'use client';

import {Header as TeamPlanHeader} from '@/components/header/team-plan-header/team-plan';
import {Footer as TeamPlanFooter} from '@/components/footer/team-plan-footer/team-plan';
import {ToasterProvider} from '@/components/toaster-provider/toaster-provider';

/** Shared shell for team plan signup flows (buy now and free trial). */
export default function TeamPlanSignupLayout({children}: {children: React.ReactNode}) {
    return (
        <>
            <TeamPlanHeader />
            {children}
            <TeamPlanFooter />
            <ToasterProvider />
        </>
    );
}
